export const ExplanationData = [
  {
    page: 1,
    list: [
      [
        { 
          id: 1, 
          text: "특수고용형태종사자란?", 
          type: "title" 
        },
        {
          id: 2,
          text: "계약 형태와 관계없이 노무를 제공하여 근로하고 있는 경우",
          type: "list",
        },
        {
          id: 3,
          text: "포함 업종: 학습지교사, 학원 강사, 방문판매원, 보험설계사, 북큐레이터, 번역가, 택배기사, 골프장캐디, 퀵서비스 기사, 대리운전기사, 건설기계를 직접 운정하는 사람 등",
          type: "list",
        },
      ]
    ],
  },
  {
    page: "checkList",
    list: [
      [
        { 
          id: 1, 
          text: "중위소득이란,", 
          type: "title" 
        },
        {
          id: 2,
          text: "국민의 총 가구의 소득에 따라 오름차순으로 배열하여 정확히 중앙에 있는 값을 말합니다! 본인 가구 수와 소득에 따라 계산됩니다.",
          type: "list",
        },
      ],
      [
        { 
          id: 1, 
          text: "※ 21년도 기준 (1인가구 기준)", 
          type: "title" 
        },
        {
          id: 2,
          text: "중위소득: 1,827,832원",
          type: "list",
        },
        {
          id: 3,
          text: "50%: 913,916원",
          type: "list",
        },
        {
          id: 4,
          text: "60%: 1,096,699원",
          type: "list",
        },
        {
          id: 5,
          text: "22년도 중위소득: 1,944,812원",
          type: "list",
        },
      ],
    ],
  },
];
